define('SageDotCom/Components/ProductCardAddonSelector',["jquery",
    "eventManager",
    "SageDotCom/DataLayer/tealium",
    "SageDotCom/Components/ProductCard/ProductCardSelection"],
    function ($, eventManager, tealium, productCardSelection) {

        function ProductCardAddonSelector(scope, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer) {
            ///<summary>Initialize a new instance of FlexBox. Subscribe to messages which are passed to current instance.</summary>

            var self = this;
            Object.defineProperties(this,
                {
                    scope: { enumerable: true, value: scope },
                    $scope: { enumerable: true, value: $(scope) },
                    stateChangeMessages: { enumerable: true, value: stateChangeMessages.slice() }
                });

            setTimeout(function () {
                const $addonChk = $(scope).find('.addon-chk');
                if ($addonChk) {
                    const buyButtonWithModal = $addonChk.closest("[data-attr-id^=productcardaddonselector]").nextAll(".sage-modal-button");
                    const buyButton = $addonChk.closest("[data-attr-id^=productcardaddonselector]").nextAll("[id^=productbuybutton]");
                    if (buyButtonWithModal.length == 1) {
                        buyButtonWithModal.addClass("sage-product-card-cta-wrapper-alt");
                    }
                    if (buyButtonWithModal.length == 1 && buyButton.length == 1)
                    if ($addonChk.prop('checked')) {
                        buyButtonWithModal.hide();
                        buyButton.show();
                    } else {
                        buyButtonWithModal.show();
                        buyButton.hide();
                    }
                }
            }, 5);

            $(scope).delegate('.addon-chk','click',
                function () {
                    setTimeout(function () {
                        $('.sage-product-card-tooltip-icon').each(function () {
                            $(this).tooltip('destroy');
                        });
                    }, 10);

                    productCardSelection.setProductCardValue("checkbox",$(this).is(":checked"),$(scope).closest('.sage-product-card,.sage-product-card-alt').attr("data-pid"));

                    //save current index
                    var selectedIndex = 0;
                    if ($(scope).closest('.sage-product-card,.sage-product-card-alt').find('select:visible').length > 0) {
                        selectedIndex = $(scope).closest('.sage-product-card,.sage-product-card-alt').find('select:visible').find(':selected')
                            .index();
                    }

                    //get addon id from checkbox and switch labels
                    var labelCheck = '';
                    var $productCardBuyButton = $(this).closest("[data-attr-id^=productcardaddonselector]").nextAll("[id^=productbuybutton]");
                    var $productCardBuyButtonWithModal = $(this).closest("[data-attr-id^=productcardaddonselector]").nextAll(".sage-modal-button");
                    if ($(this).prop('checked')) {
                        var textContent = $(this).attr('data-remove');
                        if ($(this).parent().hasClass("switch")) {
                            $($(this).closest('label')).find('[class*="sage-product-card-addon-label"]').text(textContent);
                        } else {
                            $(this).parent().find('label').text(textContent);
                        }
                        if ($productCardBuyButton.length === 1 && $productCardBuyButtonWithModal.length === 1) {
                            $productCardBuyButtonWithModal.hide();
                            $productCardBuyButton.show();
                        }
                    } else {
                        var textContent = $(this).attr('data-add');
                        if ($(this).parent().hasClass("switch")) {
                            $($(this).closest('label')).find('[class*="sage-product-card-addon-label"]').text(textContent);
                        } else {
                            $(this).parent().find('label').text(textContent);
                        }
                        if ($productCardBuyButton.length === 1 && $productCardBuyButtonWithModal.length === 1) {
                            $productCardBuyButtonWithModal.show();
                            $productCardBuyButton.hide();
                        }
                    }

                    var eventName = 'productCardPriceChange:' + $(scope).closest('.sage-product-card,.sage-product-card-alt').parent()[0].id;
                    var productName = $(scope).closest('.sage-product-card,.sage-product-card-alt').find(".sage-product-card-title").text();
                    eventManager.trigger(eventName, $(scope).closest('.sage-product-card,.sage-product-card-alt').parent());
                    eventManager.trigger('product card refresh heights', $(scope).closest('.sage-product-card,.sage-product-card-alt').parent());
                    eventManager.trigger("product card detail event", "checkbox", "", true, productName);

                    if ($('.button-tertiary').length) {
                        $('<span class="bottom-line"></span>').appendTo('.product-card-cta-tertiary-alt');
                    }

                    setTimeout(function () {
                        $('.sage-product-card-tooltip tr').each(function () {
                            if ($(this).find('span').is(':empty')) {
                                $(this).css('display', 'none');
                            } else {
                                $(this).css('display', '');
                            }
                        });

                        $('.sage-product-card-tooltip-icon').each(function () {
                            $(this).tooltip(
                                {
                                    html: true,
                                    placement: 'bottom',
                                    title: $('#' + $(this).data('tip')).html()
                                });
                        });
                    }, 500);
                });

            if (onShowMessagesPerformer.length) {
                onShowMessagesPerformer.forEach(function (messageName) {
                    eventManager.subscribe(messageName, self.show, self);
                });

            }
            if (onHideMessagePerformer.length) {
                onHideMessagePerformer.forEach(function (messageName) {
                    eventManager.subscribe(messageName, self.hide, self);
                });
            }
        }

        ProductCardAddonSelector.prototype.show = function () {
            this.$scope.show();
        };

        ProductCardAddonSelector.prototype.hide = function () {
            this.$scope.hide();
        };
        ProductCardAddonSelector.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ProductCardAddonSelector(args.scope,
                    args.StateChangeMessagesTransmitting || [],
                    args.ShowActionMessages || [],
                    args.HideActionMessages || []);
        };

        return ProductCardAddonSelector;
    });
